import { createSelector } from '@reduxjs/toolkit';
import type { StateWithSinatra } from '../types';
import { CapstoneFollowUpReplyNotifications } from '../types/Organization';
import { selectUser } from './selectUser';

/** Mirrors the follow-up reply sound defaults. */
const defaultFollowUpReplyNotifications: Required<CapstoneFollowUpReplyNotifications> =
  {
    active_participants: { banner_on: true },
    everyone_else: { banner_on: false },
  };

/**
 * Merged per role rather than at the top level: an agency that has only ever
 * changed one role would otherwise lose the other's default.
 */
export const selectFollowUpReplyNotifications = createSelector(
  [selectUser],
  (user): Required<CapstoneFollowUpReplyNotifications> => {
    const stored =
      user.currentOrg?.attributes?.capstone?.follow_up_reply_notifications;
    return {
      active_participants: {
        ...defaultFollowUpReplyNotifications.active_participants,
        ...stored?.active_participants,
      },
      everyone_else: {
        ...defaultFollowUpReplyNotifications.everyone_else,
        ...stored?.everyone_else,
      },
    };
  },
);

export const selectIsFollowUpReplyBannerEnabled = (
  state: StateWithSinatra,
  isParticipant: boolean,
): boolean => {
  const settings = selectFollowUpReplyNotifications(state);
  return isParticipant
    ? settings.active_participants.banner_on
    : settings.everyone_else.banner_on;
};
